/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseLodash;
